import React from 'react';
import { motion } from 'framer-motion';
import { AuthProvider } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import LoginModal from './components/LoginModal';
import Hero from './components/Hero';
import About from './components/About';
import Biography from './components/Biography';
import Quotes from './components/Quotes';
import LifeStories from './components/LifeStories';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Memories from './components/Memories';
import Collection3D from './components/Collection3D';
import Letters from './components/Letters';
import ArtGallery from './components/ArtGallery';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Sidebar />
        <LoginModal />
        <motion.main className="main-content">
          <Hero />
          <About />
          <Biography />
          <Quotes />
          <LifeStories />
          <Skills />
          <Projects />
          <Experience />
          <Memories />
          <Collection3D />
          <Letters />
          <ArtGallery />
          <Gallery />
          <Contact />
          <Footer />
        </motion.main>
      </div>
    </AuthProvider>
  );
}

export default App;
